import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import useAutoAddQueryString from "../../Helpers/useAutoAddQueryString";
import { getAboutClubText } from "../../Slice/CommonSlice";
import ReactHtmlParser from "react-html-parser";

const HowItWorks = () => {
  useAutoAddQueryString();
  const dispatch = useDispatch();
  const { cmsData, isLoading } = useSelector((state) => state.common);

  useEffect(() => {
    dispatch(getAboutClubText(5));
  }, [dispatch]);

  const isValidCanvaLink = (url) => {
    return (
      typeof url === "string" &&
      url.trim() !== "" &&
      url.startsWith("https://www.canva.com/")
    );
  };

  const renderResponsiveEmbed = (code) => {
    if (!code) return null;

    const responsiveCode = code
      .replace(/width="\d+"/g, 'width="100%"')
      .replace(/height="\d+"/g, 'height="100%"');

    return (
      <div
        style={{
          position: "relative",
          paddingBottom: "56.25%",
          height: 0,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
        >
          {ReactHtmlParser(responsiveCode)}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="middle-section">
        <div className="container">
          <div className="innerwhite-section">
            <div className="heading">
              <h2>How It Works</h2>
            </div>
            <div
              className="accordion ruleaccordion howtoplayaccordion"
              id="accordionExample"
            >
              {cmsData &&
                cmsData.map((item, key) => {
                  const isFirst = key === 0;
                  return (
                    <div className="accordion-item" key={key}>
                      <h2 className="accordion-header" id={`heading${key}`}>
                        <strong>{key + 1}</strong> {item.text1}
                        <span
                          data-bs-toggle="modal"
                          data-bs-target="#howtoplay"
                        >
                          <i className="far fa-image"></i>
                        </span>
                        <button
                          className={`accordion-button ${
                            isFirst ? "" : "collapsed"
                          }`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse${key}`}
                          aria-expanded={isFirst ? "true" : "false"}
                          aria-controls={`collapse${key}`}
                        ></button>
                      </h2>
                      <div
                        id={`collapse${key}`}
                        className={`accordion-collapse collapse ${
                          isFirst ? "show" : ""
                        }`}
                        aria-labelledby={`heading${key}`}
                        data-bs-parent="#accordionExample"
                      >
                        <div
                          className="accordion-body"
                          style={{ maxHeight: "500px" }}
                        >
                          {isValidCanvaLink(item?.text3) ? (
                            <iframe
                              loading="lazy"
                              style={{ width: "100%", height: "500px" }}
                              src={item.text3}
                              allowFullScreen
                              allow="fullscreen"
                              title="Canva Design"
                            ></iframe>
                          ) : item?.embed_code ? (
                            renderResponsiveEmbed(item.embed_code)
                          ) : (
                            ReactHtmlParser(item.text2)
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HowItWorks;
